import classnames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import * as digitalData from '@ao-internal/digital-data';

import TRANSLATIONS from './translations@default.json';

const TradingRangeFlag = ({
	name,
	copy,
	flagColour,
	copyTextColour,
	copyBackgroundColour,
	enableHover = false,
	small,
	isFeatured,
}) => {
	const [hovered, setLocalHover] = useState(false);
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (!name || !copy) {
		return null;
	}

	const toggleHover = (isHovered, trackEvent) => {
		setLocalHover(() => isHovered);

		// Hover events are currently not supported in new tracking library
		if (trackEvent) {
			digitalData.sendBeacon('TrackHover', {
				tradingRangeFlagTheme: name,
				type: 'hover',
			});
		}
	};

	return (
		<div
			className={classnames(
				'top-0 left-0 z-10 transition-opacity text-xs absolute flex cursor-default',
				copyBackgroundColour,
				{
					'text-sm': !small,
					'rounded-tl-lg rounded-br-md': !CustomCategoriesEnabled,
					'rounded-br': CustomCategoriesEnabled,
					'rounded-tl-sm': CustomCategoriesEnabled && isFeatured,
					'rounded-tl': CustomCategoriesEnabled && !isFeatured,
				}
			)}>
			<div
				data-testid="trading-range-flag-button"
				role="button"
				tabIndex="0"
				className={classnames(
					flagColour,
					'inline-block rounded-br py-1 px-3 font-heading',
					{
						'rounded-tl-lg': !CustomCategoriesEnabled,
						'rounded-tl-sm': CustomCategoriesEnabled && isFeatured,
						'rounded-tl': CustomCategoriesEnabled && !isFeatured,
					}
				)}
				onMouseEnter={() => enableHover && toggleHover(true, true)}
				onMouseLeave={() => enableHover && toggleHover(false)}>
				{TRANSLATIONS.bestFor}{' '}
				<span className="font-bold not-italic">{name}</span>
			</div>
			<div
				className={classnames('text-body-sm py-1 px-2', copyTextColour, {
					hidden: !hovered,
				})}>
				{copy}
			</div>
		</div>
	);
};

export default TradingRangeFlag;
